module.exports = __webpack_public_path__ + "img/13.9866464c.png";